import { TPageSpeed, TPageSpeedResponse } from "domain/entities/page-speed-response";
import moment from "moment";

export class PageSpeedModel {
  static from(
    pageSpeedResponse: TPageSpeedResponse
  ): TPageSpeed {
    return {
      range: pageSpeedResponse.range,
      cards: pageSpeedResponse.cards,
      speeds: {
        dataColumns: [
          {
            header: "Page",
            accessor: "pageName",
          },
          {
            header: "Report Date",
            accessor: "reportDate",
          },
          {
            header: "Desktop Score / Speed",
            accessor: "desktopScoreSpeed",
          },

          {
            header: "Mobile Score / Speed",
            accessor: "mobileScoreSpeed",
          },
        ],
        dataRows: pageSpeedResponse.speeds.map(
          (speed) => {
            return {
              pageName: speed.pageName,
              reportDate: moment.utc(speed.reportDate).local().format('MM/DD/YYYY hh:mm a'),
              desktopScore: speed.desktopScore,
              desktopScoreSpeed: `${speed.desktopScore} / ${speed.desktopSpeed}`,
              mobileScore: speed.mobileScore,
              mobileScoreSpeed: `${speed.mobileScore} / ${speed.mobileSpeed}`,
            };
          }
        ),
      },
    };
  }
}